// extracted by mini-css-extract-plugin
export var welcomeProBadge = "ProWelcome-module__welcomeProBadge___vYtgt";
export var topImage = "ProWelcome-module__topImage___MMzj8";
export var welcomeText = "ProWelcome-module__welcomeText___LJ5ai";
export var welcome = "ProWelcome-module__welcome___LqB2v";
export var mobile = "ProWelcome-module__mobile___Fhruw";
export var proWelcome = "ProWelcome-module__proWelcome___wjNBD";
export var heading = "ProWelcome-module__heading___PCl0A";